import React from 'react';
import { t } from 'Src/i18n';
import { Button } from 'Components/frameworks/button/Button';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
import { ICONS } from 'Components/utils/icon/icons';
import { Tooltip } from 'Components/frameworks/tooltip/Tooltip';
import { getTotalDifferentialPrice } from 'Utils/transport/transportUtils';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
type TransportSelectionProps = {
  isPlane: boolean;
  isSelected?: boolean;
  isTransportRecommended?: boolean;
  alternativeTransportPrice?: AlternativeTransportPrice;
  className?: string;
  setSelectedTransport: (transportId: string) => void;
};
export function TransportSelection({
  isPlane,
  isSelected,
  isTransportRecommended,
  alternativeTransportPrice,
  className,
  setSelectedTransport,
}: TransportSelectionProps) {
  const { id, totalDifferentialPrice } = alternativeTransportPrice || {};
  const { trackClickEvent } = useTrackEvent();
  return (
    <div className={className} data-testid="TransportSelection">
      <div className="flex h-full w-full items-center justify-center rounded-12 bg-white shadow-bottomDiffuse">
        <div className="flex w-full flex-col p-20 text-center">
          {isSelected ? (
            <React.Fragment>
              <div className="flex justify-center">
                <Icon className="text-success" name={ICONS.CHECK_FILLED} width="3rem" />
              </div>
              <p className="text-24 font-bold leading-normal">
                {t('booking.transport.selectedFlight.selection')}
              </p>
              <p className="text-12 leading-1 text-mediumGrey">
                {t('booking.transport.selectedFlight.label')}
              </p>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {totalDifferentialPrice && (
                <p className="text-20 font-semibold leading-normal">
                  {getTotalDifferentialPrice(totalDifferentialPrice)}
                </p>
              )}
              <p className="mb-20 text-12 leading-1 text-mediumGrey">
                {t('booking.transport.selectedFlight.priceDifference')}
              </p>
              <Button
                className="text-16 font-semibold"
                data-selector="transportSelection-cta"
                data-testid="TransportSelectionCta"
                onClick={() => {
                  trackClickEvent(TRACK_EVENT_NAMES.CLICK_TRANSPORT_LAYER, {
                    detail_click: 'validate_new_flight',
                  });
                  setSelectedTransport(id);
                }}
                size="medium"
              >
                {t('booking.transport.planeTicket.CTASelectTransportLabel')}
              </Button>
            </React.Fragment>
          )}
          {isTransportRecommended && (
            <Tooltip
              modalProps={{
                closeLabel: t('common.close'),
                size: 'small',
                children: null,
              }}
              renderTrigger={(toggle) => (
                <button
                  type="button"
                  onClick={toggle}
                  className="mt-20 flex items-center justify-center gap-4"
                  data-testid="TransportSelectionRecommendedTooltip"
                >
                  <span className="text-12 text-green underline">
                    {t(
                      isPlane
                        ? 'booking.transport.transportRecommendationLabel'
                        : 'booking.transport.otherTransportRecommendationLabel',
                    )}
                  </span>
                  <Icon className="text-success" name={ICONS.CHECK} width="1rem" />
                </button>
              )}
            >
              <div className="p-20">
                <Text
                  className="mb-10 text-12"
                  text={t(
                    isPlane
                      ? 'booking.transport.transportRecommendationInformation'
                      : 'booking.transport.otherTransportRecommendationInformation',
                  )}
                />
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
}
